import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
// import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
// import logo from "./logo.svg";
import { headerHeight } from "../shareParams"

const useStyles = makeStyles(theme => ({
    root: {
        boxShadow: 'none'
    },
    flexGrow: {
        flexGrow: 1
    },
    button: {
        marginLeft: theme.spacing(1)
    },
    override : {
      minHeight : headerHeight
    }
}));

export const Topbar = (props) => {
    const { className, onSidebarOpen, onLogout, ...rest } = props;
    const classes = useStyles();
    // const [notifications] = useState([]);
    return (
      <AppBar {...rest} className={clsx(classes.root, className)}>
        <Toolbar className={classes.override}>
          <RouterLink to="/">
            {/* <img alt="Logo" src={logo}/> */}
          </RouterLink>
          <div className={classes.flexGrow}/>
          {
            onLogout && <IconButton size="small" className={classes.button} color="inherit" onClick={onLogout}>
              <InputIcon />
            </IconButton>
          }
          <Hidden mdUp>
            <IconButton size="small" className={classes.button} color="inherit" onClick={onSidebarOpen}>
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>
    );
};
